import usedColors from "fantastic/lib/usedColors";

tinymce.PluginManager.add('colorpicker2', (editor, url) => {
  const addSectionsColors = () => {
    const customEmptyColors = document.getElementsByClassName("mce-custom-color-btn")
    const colors = usedColors({sections: window.store.getState().sections});

    Array.from(customEmptyColors).forEach((tr) => {
      const element = tr.closest('tbody').lastElementChild;
      const div = element.getElementsByTagName('div')

      Array.from(div).forEach((el, index)=>{
        el.style.background = colors[index]
        el.setAttribute("data-mce-color", colors[index])
      })
    });
  }

  editor.addButton('forecolor2', {
    ...editor.buttons.forecolor,
    onshow: addSectionsColors
  })

  editor.addButton('backcolor2', {
    ...editor.buttons.backcolor,
    onshow: addSectionsColors
  })
});

